export type MyAppsEntryKind = 'app' | 'link';

export const MY_APPS_CATEGORIES = [
  'Utilities',
  'Productivity',
  'IT Tools',
  'Analytics',
  'Microsoft 365'
] as const;

export type MyAppsEntryCategory = (typeof MY_APPS_CATEGORIES)[number];

export interface MyAppsCatalogItem {
  id: string;
  title: string;
  description: string;
  category: string;
  minRole: string;
  enabled: boolean;
  defaultEnabled: boolean;
}

export interface MyAppsExternalApp {
  id: string;
  title: string;
  description: string;
  category: string;
  icon: string;
  path: string;
  url: string;
  kind: string;
}

export interface MyAppsState {
  catalog: MyAppsCatalogItem[];
  enabledAppIds: string[];
  pinnedToolIds: string[];
  recentToolIds: string[];
  externalApps: MyAppsExternalApp[];
}

export interface MyAppsUpdateRequest {
  enabledAppIds?: string[];
  pinnedToolIds?: string[];
  recentToolIds?: string[];
}

/**
 * Presentation for a built-in app. The server catalog decides which ids a user may see;
 * this supplies the icon, route, and extra search text for those ids.
 */
export interface MyAppsRegistryEntry {
  id: string;
  path: string;
  icon: string;
  keywords?: readonly string[];
}

export interface MyAppsSearchResult {
  id: string;
  title: string;
  description: string;
  path: string;
  icon: string;
  searchText: string;
  kind: MyAppsEntryKind;
  category: MyAppsEntryCategory;
  url?: string;
}
